<div class="filter"><div class="filter__col pointer" data-micromodal="modal-filter">Показать:<span class="filter__item js-check-all-text">Все</span></div></div>